import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { DealerState, UpdatePlantsAction, UpdateSitesAction } from 'src/app/shared/state/DealerState';
import { PlantService } from './plant.service';
import { SiteService } from './site.service';

@Injectable({ providedIn: 'root' })
export class LocationService {
  public store = inject(Store);
  public plantService = inject(PlantService);
  public siteService = inject(SiteService);

  constructor() {}

  fetchPlants(dealerId: string): void {
    const plants = this.store.selectSnapshot(DealerState.plants);
    if (plants && plants.length > 0) {
      return;
    } else {
      this.plantService.getPlants(dealerId).subscribe((plants) => {
        this.store.dispatch(new UpdatePlantsAction(plants));
      });
    }
  }

  fetchSites(dealerId: string): void {
    const sites = this.store.selectSnapshot(DealerState.sites);
    if (sites && sites.length > 0) {
      return;
    } else {
      this.siteService.getSites(dealerId).subscribe((sites) => {
        this.store.dispatch(new UpdateSitesAction(sites));
      });
    }
  }
}
